import { NextSeo } from "next-seo";
import { useState } from "react";
import useSWR from "swr";
import NoData from "../../components/common/NoData";

import TextNavBackground from "../../components/common/TextNavBackground";
import NewsCard from "../../components/elements/news/NewsCard";
import { apiWrapper } from "../../utils/api/apiWrapper";
import { kLatestNewsListURL } from "../../utils/constants/apiUrls";
import { GUEST_TOKEN } from "../../utils/constants/names";
import { getApiToken } from "../../utils/helpers/helpers";
import {
  TEN_MINUTES_REFRESH_INTERVAL_SECONDS,
  ONE_HOUR_FIFTEEN_MINUTES_REFRESH_INTERVAL_MILLISECONDS,
} from "../../utils/constants/numbers";

const NewsList = ({ news }) => {
  const [pageIndex, setPageIndex] = useState(1);

  const token = getApiToken();
  const { data: latestNews } = useSWR(
    [`${kLatestNewsListURL}?page=${pageIndex}`, token],
    {
      fallbackData: news,
      refreshInterval: TEN_MINUTES_REFRESH_INTERVAL_SECONDS,
      focusThrottleInterval:
        ONE_HOUR_FIFTEEN_MINUTES_REFRESH_INTERVAL_MILLISECONDS,
    },
  );

  const { total_pages: totalPages } = latestNews;
  const {
    count,
    next: nextPageUrl,
    previous: previousPageUrl,
    results: newsList,
  } = latestNews?.data;

  const allNews = newsList;

  return (
    <>
      <NextSeo title="News"></NextSeo>

      <TextNavBackground title="News" />

      {allNews.length !== 0 && (
        <>
          <section>
            <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
              <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:gap-x-8">
                {allNews.map((article) => {
                  return <NewsCard key={article.id} article={article} />;
                })}
              </div>
            </div>
          </section>

          <nav
            className="px-4 py-3 flex items-center justify-center sm:px-6 mb-20"
            aria-label="Pagination"
          >
            <div className="flex justify-between items-center sm:justify-center">
              <button
                disabled={!previousPageUrl}
                onClick={() => setPageIndex(!pageIndex ? 1 : pageIndex - 1)}
                className="relative inline-flex items-center px-4 py-2 border disabled:border-gray-300 border-gray-900 text-sm font-medium rounded-md disabled:text-gray-300  text-gray-700 bg-white disabled:bg-gray-100 hover:bg-gray-50"
              >
                {" "}
                Previous{" "}
              </button>

              <button
                disabled={!nextPageUrl}
                onClick={() =>
                  setPageIndex(
                    nextPageUrl ? nextPageUrl?.split("page=")[1] : totalPages,
                  )
                }
                className="ml-3 relative inline-flex items-center px-4 py-2 border disabled:border-gray-300 border-gray-900 text-sm font-medium rounded-md disabled:text-gray-300  text-gray-700 bg-white disabled:bg-gray-100 hover:bg-gray-50"
              >
                {" "}
                Next{" "}
              </button>
            </div>
          </nav>
        </>
      )}

      {allNews.length === 0 && <NoData />}
    </>
  );
};

export default NewsList;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const news = await apiWrapper.get(kLatestNewsListURL, token);

  return {
    props: {
      news,
    },
    revalidate: TEN_MINUTES_REFRESH_INTERVAL_SECONDS,
  };
};
